import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "gfu-countdown-circle" }
const _hoisted_2 = ["width", "height"]
const _hoisted_3 = ["cx", "cy", "r"]
const _hoisted_4 = ["cx", "cy", "r", "stroke", "stroke-width", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "transform"]
const _hoisted_5 = {
  class: "gfu-countdown-circle__time",
  "data-qa": "countdown-circle-time"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", {
      width: $props.size,
      height: $props.size,
      style: {"transform":"rotateY(180deg)"}
    }, [
      _createElementVNode("circle", {
        cx: $options.circleCenter.x,
        cy: $options.circleCenter.y,
        r: $options.outerCircleRadius,
        fill: "rgba(0, 0, 0, 0.5)",
        stroke: "none"
      }, null, 8 /* PROPS */, _hoisted_3),
      _createElementVNode("circle", {
        class: "gfu-countdown-circle__progress",
        cx: $options.circleCenter.x,
        cy: $options.circleCenter.y,
        r: $options.innerCircleRadius,
        fill: "none",
        stroke: $props.strokeColor,
        "stroke-width": $props.strokeWidth,
        "stroke-dasharray": $options.strokeDashArray,
        "stroke-dashoffset": $options.strokeOffset,
        "stroke-linecap": $props.strokeLinecap,
        transform: `rotate(-90 ${$options.circleCenter.x} ${$options.circleCenter.y})`
      }, null, 8 /* PROPS */, _hoisted_4)
    ], 8 /* PROPS */, _hoisted_2)),
    _createElementVNode("div", _hoisted_5, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createTextVNode(_toDisplayString($options.formattedTime), 1 /* TEXT */)
      ])
    ])
  ]))
}